(() => {
  const headings = document.querySelectorAll('h1.product__title');

  headings.forEach((heading) => {
    // Verhindert eine erneute Bearbeitung desselben Titels
    if (heading.dataset.nfUnitNormalized === 'true') return;

    const title = (heading.textContent || '').replace(/[μµ]g/gi, 'µg');
    const parts = title.split(/(µg)/g);
    const fragment = document.createDocumentFragment();

    parts.forEach((part) => {
      if (part === 'µg') {
        const unit = document.createElement('span');
        unit.className = 'nf-product-title__unit';
        unit.textContent = 'µg';
        fragment.appendChild(unit);
      } else {
        // Erhält die bisherige Großschreibung des Titels,
        // lässt aber die Einheit µg kleingeschrieben.
        fragment.appendChild(
          document.createTextNode(part.toLocaleUpperCase('de-DE'))
        );
      }
    });

    heading.replaceChildren(fragment);
    heading.style.setProperty('text-transform', 'none', 'important');
    heading.dataset.nfUnitNormalized = 'true';
  });
})();